<template>
  <el-dialog :title="getTitle"
             :visible.sync="showRole"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="roleInfo"
               :rules="roleRules"
               ref="roleForm"
               label-width="90px"
               class="type-form">
        <el-form-item label="角色名称"
                      prop="name">
          <el-input v-model.trim="roleInfo.name"
                    placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="备注:"
                      prop="remark">
          <el-input type="textarea"
                    v-model="roleInfo.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="handleCancel('roleForm')">取 消</el-button>
      <el-button v-has="'/role/add' || '/role/edit'"
                 type="primary"
                 @click="handleConfirm('roleForm')">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showRole: this.isShow,
      roleInfo: {
        name: '',
        creator: localStorage.getItem('uId'),
        remark: ''
      },
      roleRules: {
        name: [{ required: true, message: '请输入角色名称' }]
      }
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加角色' : '编辑角色'
    }
  },
  created() {
    console.log(this.data.type)
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getRoleInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roleInfo.name = data.name
            this.roleInfo.remark = data.remark
            this.roleInfo.creator = localStorage.getItem('uId')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addRole({ ...this.roleInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch
              .editRole({ ...this.roleInfo, id: this.data.id })
              .then((data) => {
                data.procData(
                  data.res,
                  () => {
                    this.$message.success('操作成功')
                    this.handleCancel('refresh')
                  },
                  (err) => {
                    this.$message.error(err)
                  }
                )
              })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
